import { render, staticRenderFns } from "./BuilderAdminSidebar.vue?vue&type=template&id=c671c474"
import script from "./BuilderAdminSidebar.vue?vue&type=script&lang=js"
export * from "./BuilderAdminSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports